import { HugeiconsIcon } from "@hugeicons/react";
import {
  Backpack03Icon,
  DashboardSquare02Icon,
  File01Icon,
  Hotel01Icon,
  NewOfficeIcon,
  NewsIcon,
  PackageDimensionsIcon,
  RocketIcon,
  Target02Icon,
  UserSharingIcon,
} from "@hugeicons/core-free-icons";
const clientMenu = [
  {
    id: 1,
    name: "Dashboard",
    icon: <HugeiconsIcon icon={DashboardSquare02Icon} />,
    path: "/client/dashboard",
  },
  {
    id: 2,
    name: "All Bookings",
    icon: <HugeiconsIcon icon={RocketIcon} />,
    children: [
      {
        id: 1,
        name: "Hotel Bookings",
        path: "/client/hotel/booking",
      },
    ],
  },

  {
    id: 5,
    name: "Hotel Management",
    icon: <HugeiconsIcon icon={Hotel01Icon} />,
    children: [
      {
        id: 1,
        name: "Room Availability",
        path: "/client/hotel/availability",
      },
    ],
  },
];

export default clientMenu;
